// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 1px !important;
  border: none !important;
  --border-radius: 16px !important;
}

ion-input {
  --border: none !important;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent ;
}

.wrapper {
  padding: 20px;
}

.privacy-btn {
  margin-left: 5px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

.stacked {
  position: relative;
  z-index: 2;
  left: 20px;
  top: 7px;
  background: white;
  padding: 0px 5px;
}

.stacked {
  position: static;
  top: 0px;
  left: 0px;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-secondary);
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--ion-color-secondary);
}
.input-age ion-input:first-child {
  border-right: 1px solid #CBD5E1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #CBD5E1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
.button-wrapper ion-button.google {
  --background: #D0463B;
}
.button-wrapper ion-button.facebook {
  --background: #3B5997;
}
.button-wrapper ion-button.apple {
  --background: black;
}

ion-select::part(icon) {
  position: absolute;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-up/sign-up.page.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAIA;EACE,8BAAA;EACA,uBAAA;EACA,gCAAA;AADF;;AAIA;EACE,yBAAA;EACA,iCAAA;EACA,gCAAA;AADF;;AAIA;EACE,kBAAA;EACA,0BAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,mBAAA;AADF;;AAIA;EACE,oBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AADF;;AAMA;EACE,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAHF;;AAMA;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;AAHF;;AAOE;EACE,YAAA;EACA,kBAAA;EACA,iCAAA;AAJJ;AAOE;EACE,+BAAA;AALJ;AAQE;EACE,8BAAA;AANJ;;AAUA;EACE,yBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,YAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAPF;AASE;EACE,WAAA;EACA,gBAAA;AAPJ;AAUE;EACE,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AATJ;AAWI;EACE,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AATN;AAYI;EACE,kBAAA;EACA,SAAA;AAVN;AAaI;EACE,qBAAA;AAXN;AAcI;EACE,qBAAA;AAZN;AAeI;EACE,mBAAA;AAbN;;AAkBA;EACE,kBAAA;EACA,QAAA;AAfF","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\nion-item {\n  --border-width: 1px !important;\n  border: none !important;\n  --border-radius: 16px !important;\n}\n\nion-input {\n  --border: none !important;\n  color: var(--ion-color-secondary);\n  font-family: AppFont, sans-serif;\n}\n\n.no-line {\n  border-bottom: 0px;\n  --background: transparent\n}\n\n.wrapper {\n  padding: 20px;\n}\n\n.privacy-btn {\n  margin-left: 5px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  --border-radius: 5px;\n  margin-bottom: 0;\n}\n\n.stacked {\n  position: relative;\n  z-index: 2;\n  left: 20px;\n  top: 7px;\n  background: white;\n  padding: 0px 5px;\n}\n\n\n\n.stacked {\n  position: static;\n  top: 0px;\n  left: 0px;\n  z-index: 2;\n}\n\nion-label {\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-secondary);\n}\n\n.input-age {\n  ion-input {\n    height: 100%;\n    text-align: center;\n    color: var(--ion-color-secondary);\n  }\n\n  ion-input:first-child {\n    border-right: 1px solid #CBD5E1;\n  }\n\n  ion-input:last-child {\n    border-left: 1px solid #CBD5E1;\n  }\n}\n\nion-footer {\n  --background: transparent;\n  box-shadow: none;\n}\n\n.loading {\n  height: 50vh;\n  align-items: center;\n}\n\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n\n  ion-button {\n    width: 100%;\n    margin: 10px 0px\n  }\n\n  ion-button {\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    p {\n      margin-top: 5px;\n      font-family: AppFontBold, sans-serif;\n      color: white;\n      width: 75%;\n    }\n\n    ion-icon {\n      margin-right: 10px;\n      zoom: 0.9;\n    }\n\n    &.google {\n      --background: #D0463B;\n    }\n\n    &.facebook {\n      --background: #3B5997;\n    }\n\n    &.apple {\n      --background: black;\n    }\n  }\n}\n\nion-select::part(icon) {\n  position: absolute;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
